/* global grecaptcha */
import React, { Component } from "react";
import axios from "axios";
import { detect } from "detect-browser";
import { notifyOfPartialJobPath } from "../../resources/ApiEndpoints";
import { Wrapper, FormWrapper, Title, Form } from "./styles/create-form-styles";
import FormStep from "./FormSteps/FormStep";
import InternetExplorerSupport from "../shared/general/InternetExplorerSupport";

class CreateAccountForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      errors: {},
      fullName: "",
      email: "",
      phone: "",
      jobTitle: "",
      jobLocation: "",
      terms: false,
      recaptcha: process.env.RAILS_ENV === "test",
      ieMessageActive: detect().name === "ie",
    };
  }

  componentDidMount() {
    const isIe = detect().name === "ie";

    if (isIe) {
      document.body.classList.add("internet-explorer");
    }
  }

  handleRecaptcha = () => {
    const { recaptcha, errors } = this.state;

    if (!recaptcha) {
      this.setState({ recaptcha: !recaptcha });
    }

    errors.recaptcha = "";
    this.setState({ errors });
  };

  handleFormStep = (e, direction) => {
    e.preventDefault();
    const { step } = this.state;

    if (direction === "forward") {
      this.validateAndMoveForward();
    } else if (direction === "backward") {
      this.setState({
        step: step - 1,
      });
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  validateAndMoveForward = () => {
    const { step, fullName, email, phone } = this.state;
    const stepOneFields = { fullName, email, phone };
    const newErrors = this.formValidation(stepOneFields);

    if (Object.keys(newErrors).length < 1) {
      this.postData(
        { full_name: fullName, email, phone },
        notifyOfPartialJobPath()
      ).then((response) => {
        if (response) {
          this.setState({ step: step + 1 });
          this.setState({ errors: {} });
        }
      });
    } else {
      this.setState({ errors: newErrors });
    }
  };

  handleInputChange = (e) => {
    const { errors } = this.state;
    errors[e.target.name] = "";

    this.setState({ [e.target.name]: e.target.value });
    this.setState({ errors });
  };

  handleCheckbox = () => {
    const { terms } = this.state;
    this.setState({ terms: !terms });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { step } = this.state;

    this.validateAndSubmit()
      .then((response) => {
        if (response) {
          this.setState({ step: step + 1 });
        } else {
          const { errors } = this.state;
          const { email, phone } = errors;

          grecaptcha.reset();

          if (email || phone) {
            this.setState({ step: step - 1 });
          }
        }
      })
      .catch(() => {});

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  validateAndSubmit = () => {
    const { fullName, email, phone, jobTitle, jobLocation, terms, recaptcha } =
      this.state;

    const stepTwoFields = { jobTitle, jobLocation, terms, recaptcha };
    const newErrors = this.formValidation(stepTwoFields);

    if (Object.keys(newErrors).length < 1) {
      const firstName = fullName.split(" ")[0];
      const lastName = fullName.split(" ")[1];
      const url = "/post-a-job-v4/intro";

      return this.postData(
        {
          email,
          first_name: firstName,
          last_name: lastName,
          title: jobTitle,
          location: jobLocation,
          phone,
          terms,
          recaptcha,
          recaptcha_token: grecaptcha.getResponse(),
        },
        url
      );
    }

    this.setState({ errors: newErrors });
    return Promise.reject();
  };

  formValidation = (fields) => {
    const newErrors = {};

    Object.keys(fields).forEach((fieldKey) => {
      if (!fields[fieldKey]) {
        newErrors[fieldKey] = "Required field.";
      }
    });

    if (fields.fullName && !fields.fullName.split(" ")[1]) {
      newErrors.fullName = "Please provide a full name.";
    }

    return newErrors;
  };

  postData = (requestData, url) => {
    const payload = {
      url,
      method: "post",
      data: requestData,
    };

    return this.axiosRequest(payload);
  };

  axiosRequest = (payload) =>
    axios(payload)
      .then(() => true)
      .catch(({ response }) => {
        this.setState({ errors: response.data.errors });
        this.convertArrayErrorsToString();
        return false;
      });

  convertArrayErrorsToString = () => {
    const { errors } = this.state;

    Object.keys(errors).map((element) => {
      if (typeof errors[element] === "object") {
        errors[element] = errors[element].join(", ");
      }

      return errors[element];
    });
  };

  closeIeMessage = () => {
    this.setState({ ieMessageActive: false });
  };

  render() {
    const {
      errors,
      step,
      fullName,
      email,
      phone,
      jobTitle,
      jobLocation,
      terms,
      ieMessageActive,
    } = this.state;
    const isIe = detect().name === "ie";

    return (
      <Wrapper isIe={isIe}>
        {ieMessageActive && (
          <InternetExplorerSupport closeIeMessage={this.closeIeMessage} />
        )}
        <FormWrapper>
          <Title className="animated fadeIn delay-2">
            {step === 3 ? "Thank you." : "Get started with Hiring Hub"}
          </Title>
          <Form onSubmit={this.handleSubmit}>
            <FormStep
              errors={errors}
              step={step}
              handleFormStep={this.handleFormStep}
              handleInputChange={this.handleInputChange}
              handleCheckbox={this.handleCheckbox}
              handleRecaptcha={this.handleRecaptcha}
              fullName={fullName}
              email={email}
              phone={phone}
              jobTitle={jobTitle}
              jobLocation={jobLocation}
              terms={terms}
            />
          </Form>
        </FormWrapper>
      </Wrapper>
    );
  }
}

export default CreateAccountForm;
